import React, { useState } from 'react';
import { API_BASE_URL } from '../urldata.js';

const BUSINESS_PLANS = [
  {
    id: 'home',
    title: 'Home Business',
    desc: 'Perfect for individuals running a small shop from home.',
    ads: '100 Ads',
    fee: 'Rs 500 / Month',
    reg: 'Waived Off'
  },
  {
    id: 'small',
    title: 'Small Shop',
    desc: 'For local toy corners and small retail outlets.',
    ads: '500 Ads',
    fee: 'Rs 1200 / Month',
    reg: 'Waived Off'
  },
  {
    id: 'store',
    title: 'Toy Store',
    desc: 'Comprehensive package for established toy showrooms.',
    ads: '2500 Ads',
    fee: 'Rs 3000 / Month',
    reg: 'Waived Off'
  },
  {
    id: 'enterprise',
    title: 'Enterprise',
    desc: 'Custom solutions for high-volume traders and brands.',
    ads: 'Unlimited*',
    fee: 'Usage Based',
    reg: 'Rs 50,000'
  }
];

function ForBusiness() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedPlan) {
      setError("Please select a business plan.");
      return;
    }

    setIsLoading(true);
    setError(null);
    setSuccessMessage(null);

    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());
    data.category = selectedPlan;

    const urlEncodedData = new URLSearchParams(data).toString();

    try {
      const response = await fetch(`${API_BASE_URL}/tapi/business/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: urlEncodedData,
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || responseData.error || `HTTP error! status: ${response.status}`);
      }

      setSuccessMessage(responseData.message || 'Registration request submitted successfully! We will get back to you soon.');
      event.target.reset();
      setSelectedPlan('');
    } catch (err) {
      console.error("Failed to submit registration:", err);
      setError(err.message || "Failed to submit registration. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-xxl py-4 text-start">
      {/* Top Banner */}
      <div className="business-banner shadow-sm">
        <div className="row g-0 align-items-center">
          <div className="col-lg-7">
            <div className="business-banner-content">
              <h1 className="fw-bold mb-3 display-5">For Business</h1>
              <p className="lead opacity-75 mb-4">
                Scale your toy business with ToyTrade. Reach thousands of verified parents and collectors across Pakistan. Our specialized business accounts offer higher listing limits, verified status, and dedicated support.
              </p>
              <div className="d-flex gap-3">
                <div className="badge bg-light text-dark p-2 px-3 rounded-pill">Higher Visibility</div>
                <div className="badge bg-light text-dark p-2 px-3 rounded-pill">Bulk Uploads</div>
                <div className="badge bg-light text-dark p-2 px-3 rounded-pill">Verified Badge</div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 d-none d-lg-block text-end">
            <img
              src="/images/app_hand.png"
              alt="ToyTrade Business"
              className="img-fluid business-banner-img"
              style={{ maxHeight: '350px' }}
            />
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-10">
          <h2 className="fw-bold mb-4">Business Registration</h2>

          <form onSubmit={handleSubmit}>
            <div className="mb-5">
              <label className="form-label fw-bold fs-5 mb-3">1. Select your pricing plan</label>
              <div className="row g-3">
                {BUSINESS_PLANS.map((plan) => (
                  <div className="col-md-6 col-xl-3" key={plan.id}>
                    <div
                      className={`plan-card shadow-sm ${selectedPlan === plan.id ? 'active' : ''}`}
                      onClick={() => setSelectedPlan(plan.id)}
                    >
                      <h5 className="fw-bold mb-2">{plan.title}</h5>
                      <p className="small text-muted mb-3" style={{ minHeight: '40px' }}>{plan.desc}</p>
                      <div className="mb-2"><strong>{plan.ads}</strong></div>
                      <div className="price mb-1">{plan.fee}</div>
                      <div className="small text-success">Reg: {plan.reg}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="row g-4">
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="email" className="form-label fw-semibold">Email Address (from App Account tab)</label>
                  <input type="email" className="form-control form-control-lg" id="email" name="email" required placeholder="name@example.com" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="displayName" className="form-label fw-semibold">Business Display Name (Public)</label>
                  <input type="text" className="form-control form-control-lg" id="displayName" name="display_name" required placeholder="e.g. Toys Kingdom Online" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="shopName" className="form-label fw-semibold">Registered Shop / Legal Entity Name</label>
                  <input type="text" className="form-control form-control-lg" id="shopName" name="shop_name" required placeholder="e.g. Toys Kingdom Private Limited" />
                </div>
              </div>
              <div className="col-12">
                <div className="mb-3">
                  <label htmlFor="address" className="form-label fw-semibold">Shop Address / Business Location</label>
                  <textarea className="form-control" id="address" name="address" rows="2" required placeholder="Full physical address"></textarea>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="city" className="form-label fw-semibold">City</label>
                  <input type="text" className="form-control form-control-lg" id="city" name="city" required placeholder="e.g. Karachi" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="contact" className="form-label fw-semibold">Contact Number</label>
                  <input type="tel" className="form-control form-control-lg" id="contact" name="contact_number" required placeholder="e.g. 03001234567" />
                </div>
              </div>
            </div>

            <div className="mt-5 text-center">
              {error && <div className="alert alert-danger mb-4">{error}</div>}
              {successMessage && <div className="alert alert-success mb-4">{successMessage}</div>}

              <button type="submit" className="btn btn-primary btn-lg px-5 py-3 fw-bold   shadow-sm" disabled={isLoading}>
                {isLoading ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Submitting...</>
                ) : (
                  'Submit Registration Request'
                )}
              </button>
              <div className="mt-4 p-3   faq-item text-start mx-auto" style={{ maxWidth: '600px' }}>
                <p className="mb-0 small text-muted">
                  <strong>Note:</strong> The Ads Limit for each plan (e.g. 100, 500, or 2500) represents the maximum number of <strong>active listings</strong> you can maintain on your store at any given time.
                </p>
              </div>
              <p className="mt-4 text-muted small">Our team will verify your details and contact you within 24-48 hours.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForBusiness;
